import { Dayjs } from "dayjs";

export interface BiorhythmData {
  date: string;
  fullDate: string;
  physical: number;
  emotional: number;
  intellectual: number;
}

const calculatePercentage = (t: number, period: number): number => {
  const sinValue = Math.sin((2 * Math.PI * t) / period);
  // Shift from [-1, 1] to [0, 100]
  return Math.round(((sinValue + 1) / 2) * 100);
};

export const calculateBiorhythm = (
  birthDate: Dayjs,
  targetDate: Dayjs,
): BiorhythmData => {
  const t = targetDate.diff(birthDate, "day");

  return {
    date: targetDate.format("MMM DD"),
    fullDate: targetDate.format("YYYY-MM-DD"),
    physical: calculatePercentage(t, 23),
    emotional: calculatePercentage(t, 28),
    intellectual: calculatePercentage(t, 33),
  };
};

export const generateBiorhythmSeries = (
  birthDate: Dayjs,
  centerDate: Dayjs,
  daysBeforeAfter: number = 15,
): BiorhythmData[] => {
  const series: BiorhythmData[] = [];

  for (let i = -daysBeforeAfter; i <= daysBeforeAfter; i++) {
    const currentDate = centerDate.add(i, "day");
    series.push(calculateBiorhythm(birthDate, currentDate));
  }

  return series;
};
